import PropTypes from 'prop-types'

const DataStorageIcon = ({ className }: { className: string }) => (
  <svg
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Builder/-Operation/-Data-Storage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="database" transform="translate(6.000000, 2.000000)" stroke="#1A56DB" strokeWidth="3">
        <path d="M0,6 L0,38 C0,41.3 8.1,44 18,44 C27.9,44 36,41.3 36,38 L36,6" id="Path"></path>
        <ellipse id="Oval" strokeLinecap="square" cx="18" cy="6" rx="18" ry="6"></ellipse>
        <path d="M36,22 C36,25.3 27.9,28 18,28 C8.1,28 0,25.3 0,22" id="Path" strokeLinecap="square"></path>
      </g>
    </g>
  </svg>
)

DataStorageIcon.displayName = 'DataStorageIcon'

DataStorageIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

DataStorageIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default DataStorageIcon
